<template>
  <div v-if="item">
    <h2>ID: #{{ item.id }}</h2>
    <div class="row">
      <div class="col-12 col-md-12">
        <fg-input type="text" label="Заголовок" v-model="item.title"></fg-input>
        <fg-input
          type="numeric"
          label="Максимальное число победителей за раз"
          v-model="item.winner_at_once"
        ></fg-input>

        <fg-input
          type="text"
          label="Название кнопки"
          v-model="item.button_text"
        ></fg-input>

        <fg-input
          type="color"
          label="Цвет текста"
          v-model="item.button_text_color"
        ></fg-input>

        <fg-input
          type="color"
          label="Цвет кнопки"
          v-model="item.button_background_color"
        ></fg-input>

        <div class="draw-image">
          <img
            :src="
              item.background_image
                ? item.background_image
                : ''
            "
            alt=""
          />

          <input
            :ref="'image'"
            :id="'image'"
            accept="image/*"
            type="file"
            @change="handleFileUpload"
          />

        </div>

        <button class="btn btn-sm btn-success btn-icon" @click="updateItem">
          <span class="ti-save"></span>
          Сохранить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**Меняю добавление модалку */
export default {
  data: () => ({
    cardLink: "admin/draws/card",
    cardSetLink: "admin/draws/update",
    item: null,
   
  }),

  props: ["id"],
  created() {
    this.getItem();
  },
  methods: {
      async handleFileUpload(event) {
      if (event.target.files && event.target.files.length === 1) {
        const file = event.target.files[0];
        const element = event.target.id;
        if (file.size > 3000000) {
            this.$notify({
            title: "Ошибка",
            message: "Файл более 3 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.item.background_image = reader.result;
        });
      }
    },
    getItem() {
      this.$loading(true);
      if (this.id) {
        this.$http
          .get(this.cardLink, {
            params: {
              id: this.id,
            },
          })
          .then((response) => {
            this.item = response.data;
          })
          .catch(() => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.$loading(false);
            }, 400);
          });
      }
    },
    updateItem() {
      this.loading = true;
      this.$loading(true);
      this.$http
        .put(this.cardSetLink, this.item)
        .then((response) => {
          this.$notify({
            title: "Успешно",
            message: "Сохранено",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style lang="scss">
.draw-image {
  position: relative;
  height: 0;
  padding-top: 50%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;
  input {
    z-index: 9;
    position: absolute;
    top:0;
    left: 0;
    right:0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  img {
    z-index: 0;
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
</style>
